<script lang="ts" setup>
// DsCount — petit compteur `.gd-count` (tones du kit).
withDefaults(defineProps<{ tone?: 'blue' | 'gray' | 'orange' | 'success' }>(), { tone: 'gray' });
</script>

<template>
  <span :class="['gd-count', `tone-${tone}`]"><slot /></span>
</template>
